(function() {
  define('templates/helpers/unlessZero',["handlebars", "underscore"], function(Handlebars, _) {
    return Handlebars.registerHelper("unlessZero", function(condition, options) {
      if (_.isObject(condition)) {
        if (_.size(condition) !== 0) {
          return options.fn(this);
        } else {
          return options.inverse(this);
        }
      } else {
        if (condition != null ? condition.length : void 0) {
          return options.fn(this);
        } else {
          return options.inverse(this);
        }
      }
    });
  });

}).call(this);

//# sourceMappingURL=unlessZero.js.map
;
